/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'; // , version
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { OtpInputComponent } from '@syncfusion/ej2-react-inputs';

import { parseISO } from 'date-fns';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
// import { getVersion } from '@syncfusion/ej2-base';
// import Otp from '../components/Otp';
import '../App.css';
import './Zackat.css';

const Login = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const { REACT_APP_API_ENDPOINT } = process.env;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const landing = `${searchParams.get('landing')}`;
  const [isVisible, setIsVisible] = useState(false);
  const [user, setUser] = useState(null);
  const {
    setIdleLogout,
  } = useStateContext();

  const hideDialog = () => {
    setIsVisible(!isVisible); // This hides the dialog
  };
  const handleValueChange = async (args) => {
    // console.log('OTP changed:', args.value, 'Length', args.value.length);
    const usr = user; // JSON.parse(localStorage.getItem('user'));
    const url = `${REACT_APP_API_ENDPOINT}/2fa?passcode=${args.value}`;
    // console.log('Get User Verify the Passcode', usr, url);
    if (usr && usr.landingPage && usr.landingPage.length > 0) {
      await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(usr),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.response === 'OK') {
            if (user.idleLogout && user.idleLogout.length > 0) {
              setIdleLogout(user.idleLogout);
              localStorage.setItem('idleLogout', user.idleLogout);
            }
            localStorage.setItem('user', JSON.stringify({
              _id: user._id,
              loggedIn: true,
              email: user.email,
              token: user.token,
              organizationid: user.organizationid,
              landingPage: user.landingPage,
            }));
            props.setLoggedIn(true);
            if (user.onboard === true) {
              navigate('/onboarding');
            } else if (landing && landing.length > 0 && landing !== 'null') {
              navigate(`/${landing}`);
            } else if (user.landingPage && user.landing !== 'null') {
              navigate(`/${user.landingPage}`);
            } else {
              navigate('/associatescontrolcenter');
            }
          }
        })
        .catch((e) => {
          DialogUtility.alert(`Error logging in ${e.message} ${REACT_APP_API_ENDPOINT}`);
        });
    }
  };

  const otpTemplate = () => {
    let p = 'Please enter your 6 digit pass code';
    if (user && user.lastReset) {
      const reset = parseISO(user.lastReset, 'MM/dd/yy hh:mm');
      const d = new Date();
      if (((d - reset) / 86400000) > 90) {
        p = `Please enter your 6 digit pass code. (Password expired! ${((d - reset) / 86400000).toFixed(0) - 90})`;
      }
    }

    return (
      <div className="bg-white rounded-3xl">
        <label>{p}</label>
        <OtpInputComponent
          id="otpinput"
          length={6}
          type="number"
          valueChanged={handleValueChange}
        />
      </div>
    );
  };
  // Call the server API to check if the given email ID already exists
  const checkAccountExists = (callback) => {
    fetch(`${REACT_APP_API_ENDPOINT}/check-account`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then((r) => r.json())
      .then((r) => {
        callback(r?.userExists);
      })
      .catch((e) => {
        DialogUtility.alert(`Error logging in ${e.message} ${REACT_APP_API_ENDPOINT}`);
      });
  };
  // Log in a user using email and password
  const logIn = () => {
    fetch(`${REACT_APP_API_ENDPOINT}/auth`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })
      .then((r) => r.json())
      .then((r) => {
        setUser(r);
        if (r.message === 'success' && (r.twoFA === 'authy' || r.twoFA === 'sms' || r.twoFA === 'email')) {
          setIsVisible(true);
        } else if (r.message === 'success') {
          if (r.idleLogout && r.idleLogout.length > 0) {
            setIdleLogout(r.idleLogout);
            localStorage.setItem('idleLogout', r.idleLogout);
          }
          localStorage.setItem('user', JSON.stringify({
            _id: r._id,
            loggedIn: true,
            email: r.email,
            token: r.token,
            organizationid: r.organizationid,
            landingPage: r.landingPage,
            onboard: r.onboard,
          }));
          props.setLoggedIn(true);
          // console.log('React', version, 'Syncfusion', getVersion());
          props.setEmail(email);
          if (r.lastReset) {
            const reset = parseISO(r.lastReset, 'MM/dd/yy hh:mm');
            const d = new Date();
            if (((d - reset) / 86400000) > 90) {
              DialogUtility.alert(`Your password has expired, please update your password! ${((d - reset) / 86400000).toFixed(0) - 90} days beyond required reset! You may change your password under your User Profile (photo), choose Change Password.`);
            }
          }
          /*
          localStorage.setItem('organization', JSON.stringify({ _id: r.organizationid, name: r.organization }));
          */
          if (r.onboard === true) {
            navigate('/onboarding');
          } else if (landing && landing.length > 0 && landing !== 'null') {
            navigate(`/${landing}`);
          } else if (r.landingPage && r.landing !== 'null') {
            navigate(`/${r.landingPage}`);
          } else {
            navigate('/associatescontrolcenter');
          }
        } else {
          DialogUtility.alert('Wrong email or password');
          navigate('/');
        }
      });
  };
  const onButtonClick = () => {
    // Set initial error values to empty
    setEmailError('');
    setPasswordError('');

    // Check if the user has entered both fields correctly
    if (email === '') {
      setEmailError('Please enter your email');
      return;
    }

    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError('Please enter a valid email');
      return;
    }
    if (password === '') {
      setPasswordError('Please enter a password');
      return;
    }

    if (password.length < 7) {
      setPasswordError('The password must be 8 characters or longer');
      return;
    }

    // Authentication calls will be made here...
    // Check if email has an account associated with it
    checkAccountExists((accountExists) => {
      // If yes, log in
      if (accountExists) logIn();
      // Else, ask user if they want to create a new account and if yes, then log in
      else if (
        DialogUtility.alert(
          `An account does not exist with this email address: ${email
          }. !`,
        )
      ) {
        navigate('/');
      }
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      logIn();
    }
  };

  return (
    <div className="flex mainContainer box zackat-div">
      <div className="titleContainer">
        <img src="./circlew3.png" width="70px" />
        <div>Login</div>
      </div>
      <br />
      <div
        className="flex inputContainer"
        style={
        {
          border: '2px solid black',
          borderRadius: '25px',
          padding: '10px',
          width: 'auto',
        }
      }
      >
        <div>
          <input
            value={email}
            placeholder="Enter your email here"
            onChange={(ev) => setEmail(ev.target.value)}
            className="inputBox"
          />
          <label className="errorLabel">{emailError}</label>
        </div>
        <br />
        <div className="inputContainer">
          <input
            value={password}
            type="password"
            placeholder="Enter your password here"
            onChange={(ev) => setPassword(ev.target.value)}
            onKeyDown={handleKeyDown}
            className="inputBox"
          />
          <label className="errorLabel">{passwordError}</label>
        </div>
        <br />
        <div className="inputContainer">
          <input className="inputButton" type="button" onClick={onButtonClick} value="Log in" />
        </div>
        <Link to="/forgot">Forgot Password </Link>
      </div>
      { isVisible
            && (
            <DialogComponent
              header={`One Time Password ${
                user.twoFA === 'authy'
                  ? 'Authenticator App'
                  : user.twoFA === 'sms'
                    ? 'SMS'
                    : 'EMAIL'
              }`}
              content={otpTemplate}
              width="35%"
              height="250px"
              isModal
              closeOnEscape
              showCloseIcon
              visible
              onClose={hideDialog}
              close={hideDialog}
            />
            )}
    </div>
  );
};
export default Login;
